.foodmap {
  transition:
    transform 0.3s ease-in-out,
    z-index 1s ease-in-out;
}
